import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Loading = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Wait 2.5 seconds then go to result
        const timer = setTimeout(() => {
            navigate('/beyond-test/result');
        }, 2500);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="beyond-test-container">
            <div className="loading-content">
                <div className="spinner"></div>
                <h2>Analyzing your ideal world...</h2>
                <p>Calculating S, E, B coordinates...</p>
            </div>

            <style jsx>{`
        .beyond-test-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #0f172a 0%, #312e81 100%);
          color: white;
          text-align: center;
        }

        .spinner {
          width: 50px;
          height: 50px;
          border: 4px solid rgba(255, 255, 255, 0.1);
          border-left-color: #a78bfa;
          border-radius: 50%;
          margin: 0 auto 2rem;
          animation: spin 1s linear infinite;
        }

        h2 {
          font-size: 1.5rem;
          margin-bottom: 0.5rem;
        }

        p {
          color: #94a3b8;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
        </div>
    );
};

export default Loading;
